import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cellular-review-decision-dialog',
  styleUrls: ['../billing-dialog.scss'],
  template: `
    <h2 mat-dialog-title>{{ data.status === 'COMPLETE' ? 'Complete monthly billing?' : data.status === 'SUBMIT_BILLING' ? 'Submit to final billing?' : data.status === 'APPROVED' ? 'Approve this report?' : 'Send back for revision?' }}</h2>
    <mat-dialog-content>
      <p *ngIf="data.status === 'APPROVED'">Version {{ data.version }} will be marked approved with your identity and timestamp. This decision is final for this version.</p>
      <p *ngIf="data.status === 'REVIEW_REQUIRED'">Your comments will be saved and emailed to {{ data.recipient }}. Support must save and submit a corrected version for another review.</p>
      <p *ngIf="data.status === 'SUBMIT_BILLING'">Save all edits as a new workflow revision and notify accounts@rabbit.run. The billing team will be able to edit this report.</p>
      <p *ngIf="data.status === 'COMPLETE'">Save and lock the final revision. Its monthly XLSX sheets will be emailed to accounts@rabbit.run, with BCC to verma@rabbit.run. This run cannot be edited after completion.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="ref.close(false)">Cancel</button>
      <button mat-raised-button color="primary" type="button" (click)="ref.close(true)">
        {{ data.status === 'COMPLETE' ? 'Complete and lock billing' : data.status === 'SUBMIT_BILLING' ? 'Submit to billing' : data.status === 'APPROVED' ? 'Confirm approval' : 'Confirm send back' }}
      </button>
    </mat-dialog-actions>
  `
})
export class CellularReviewDecisionDialogComponent {
  constructor(public ref: MatDialogRef<CellularReviewDecisionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { status: string, version: number, recipient: string }) { }
}
